import script from "./market-detail-dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./market-detail-dialog.vue?vue&type=script&setup=true&lang=js"

import "./market-detail-dialog.vue?vue&type=style&index=0&id=dc451e4c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc451e4c"]])

export default __exports__